export default __webpack_public_path__ + "static/media/Android.38d413cd.svg";